module.exports = __webpack_public_path__ + "img/why-3.567c4322.webp";